import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Authentication } from "services/api/authentication/authentication";
import { Login_Route } from "./handleRoutes/routesVar";

const ProtectedRoutes = ({ returnUrl }: { returnUrl?: boolean }) => {
  const isSignedIn = Authentication.get();
  const location = useLocation();
  if (!isSignedIn.accessToken) {
    if (returnUrl && !location.pathname.includes("panel")) {
      return (
        <Navigate
          to={Login_Route}
          state={{ returnUrl: location.pathname }}
          replace
        />
      );
    }
    return <Navigate to={Login_Route} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
